Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.





mapProximityPuckStateChange=mapProximityPuckStateChange;var _MQTTActions=require('../actions/MQTTActions');function mapProximityPuckStateChange(state){
var stateObj=state.toObject();
return(0,_MQTTActions.updateProximityPuckState)(_extends({},
stateObj,{
stateUpdatedAt:state.getStateUpdatedAt().toDate()}));

}